import React from 'react';
import styled from 'styled-components';
import { numberFormat } from "estimate_list/libs/util";

const ItemCompareList = ({ result, index }) => {
    const { market, item_id, price_info } = result;

    // 판매처 정렬
    let marketList = []
    marketList = [...market]
    if (price_info[0]?.low_card) {
        marketList.splice(1,0,price_info[0].low_card)
    }

    return (
        <div>
            <ScrollTr className={`compare_list_tr_${index}`} index={index}>
                {result.spec.map(v =>
                    v.child.map(
                        v =>
                            v.child !== undefined &&
                            v.child.map(v => {
                                return (
                                    <>
                                        <td className={`spec_option_${v.spec_name_idx}`}
                                            style={{width:"189px", fontFamily: "Noto Sans KR", fontWeight: "400", color: "#707070"}}>
                                            {v.sel_name !== ''
                                                ? v.sel_name
                                                : '-'}
                                        </td>
                                    </>
                                );
                            }),
                    ),
                )}
                <td className="scroll_list">
                    {marketList.slice(0,5).map((v,i) => {
                        return (
                            <SellerListWrapper
                                mallTextLength={v.mall_name.length}
                            >
                                <a href={v.link_out} target="_blank" className="seller_link">
                                    <div
                                        className="seller_name"
                                    >
                                        {v.mall_name}
                                    </div>
                                </a>
                                <div
                                    className="tooltip"
                                >
                                    {v.mall_name}
                                </div>
                                <a href={v.link_out} target="_blank">
                                    {i === 0
                                        ? (
                                            <div className="price_info">
                                                <span>현금 </span>{numberFormat(v.price_b2c)}
                                            </div>
                                        ) : (
                                            i === 1
                                                ? (
                                                    <div className="price_info lowest">
                                                        <span>최저 </span>{numberFormat(v.price_b2c)}
                                                    </div>
                                                ) : (
                                                    <div className="price_info nomal">
                                                        {numberFormat(v.price_b2c)}
                                                    </div>
                                                )
                                        )
                                    }
                                </a>
                            </SellerListWrapper>
                        );
                    })}
                </td>
                <MoveProductButtonWrapper>
                    <MoveProductButton
                        href={`${process.env.REACT_APP_SHOPPING_URL}/detail/${item_id}`}
                        target="_blank"
                        className="move_product_btn"
                    >
                        <span className="move_product_btn_title">
                            상품 바로가기
                        </span>
                        <span>
                            <i className="icon-angle-right"></i>
                        </span>
                    </MoveProductButton>
                </MoveProductButtonWrapper>
            </ScrollTr>
        </div>
    );
};

export default ItemCompareList;

const SellerListWrapper = styled.div`
    display: flex;
    padding: 3px;
    position: relative;

    .seller_link {
        margin-right: auto;
        z-index: 20;
        &:hover {
            text-decoration: underline;
        }
        .auto {
            flex: auto;
        }
    }
    .seller_link:hover + .tooltip {
        top: -30px;
        transition-delay: 0.3s;
        height: auto;

        z-index: 200;
        opacity: ${props => (props.mallTextLength > 5 ? '100' : '')};
        &:after {
            display: none;
        }
    }
    .seller_name {
        font-family: 'Noto Sans KR';
        font-weight: 400;
        color: #707070;
        margin-right: auto;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        width: 60px;
        height: 15px;
    }
    .price_info {
        text-align: right;
        font-family: 'Noto Sans KR';
        padding-right: 6px;
        color: #333333;
        font-weight: 600;
        span {
            font-weight: 500;
        }
    }
    .price_info.lowest {
        color: #ec0000;
    }
    .price_info.nomal {
        font-weight: 400;
    }
`;
const MoveProductButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    border-right: 1px solid #e5e5e5;
    border-bottom: 1px solid #333333;
    height: 51px;
    a {
        height: 23px;
        padding-top: 8px;
    }
`;
const MoveProductButton = styled.a`
    display: flex;
    border: 1px solid #418ded;
    padding: 6px 31px;
    border-radius: 10px;
    background-color: #418ded;
    color: #fff;
    font-size: 14px;
    font-weight: 300;
    height: 23px;
    font-family: 'Noto Sans KR';
    .move_product_btn_title {
        margin-right: 12px;
    }
    i {
        font-size: 20px;
    }
    &:hover {
        background-color: #2d7ee4;
        color: #fff;
    }
`;

const ScrollTr = styled.tr`
    width: 190px;
    .scroll_list {
        height: 108px;
        padding-top: 13px;
        padding-left: 6px;
        padding-bottom: 13px;
        width: 183px;
        position: relative;
    }
    th {
        font-weight: 800;
        width: auto !important;
        padding: 0 10px;
        background-color: #f7f7f7;
    }
    .scroll_list::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera*/
    }
    .tooltip {
       opacity: 0;
       left: 0;
       position: absolute;
       width: 100px;
       padding: 5px;
       border: 1px solid #000;
       font-size: 11px;
       color: #666;
       font-weight: 400;
       background: #fff;
       line-height: 16px;
    }
`;



// WEBPACK FOOTER //
// ./src/estimate_list/components/compareview/itemCompareList.js